/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo, useRef } from "react";

/* import images */
import { assetImages } from "constants";

// MaterialReactTable
import { MaterialReactTable } from "material-react-table";
import * as XLSX from "xlsx";

import { Link } from "react-router-dom";

import * as url from "urlhelpers/UrlHelper";
import { getData } from "utils/Gateway";

//import global utility functions
import { stringToDateTime } from "components/common/Utility.js";

//import context
import { GlobalProvider } from "context/GlobalContext";

//import translation function for language translation
import { useTranslation } from "react-i18next";

const Inbox = ({ downloadExcel, search, setRecords, checkedRecordCount, setSelectedIds }) => {
  const token = localStorage.getItem("token"); // token
  const { t } = useTranslation(); //for translation

  const {
    reloadConversationList,
    setReloadConversationList,
    setViewConversationData,
    screenHeight,
    searchMailReciever,
    setSearchMailReciever,
    searchMailSender,
    setSearchMailSender,
    searchMailSubject,
    setSearchMailSubject,
    searchMailDate,
    setSearchMailDate,
    searchMailTemplateSelect,
    setSearchMailTemplateSelect,
    searchMailLabelSelect,
    setSearchMailLabelSelect,
    searchMailReserveId,
    setSearchMailReserveId,
    setIsConversationLoading,
  } = useContext(GlobalProvider);

  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = (e) => {
    setScrollPosition(e.target.scrollLeft);
  };

  const [conversationList, setConversationList] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);
  const [rowSelection, setRowSelection] = useState({});

  const getSelectedData = () => {
    const selectedIds = Object.keys(rowSelection).filter((key) => rowSelection[key]);
    return conversationList.filter((item) => selectedIds.includes(item._id));
  };

  /* Excel export */
  const exportExcel = () => {
    const selectedData = getSelectedData();
    const exportData = selectedData.length > 0 ? selectedData : conversationList;
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Converstion.xlsx");
  };

  /* function to get all conversation data */
  const getConversationList = async () => {
    try {
      setIsConversationLoading(true);
      let requestUrl =
        url.API_BASEURL + url.API_GET_ALL_MESSAGE + `?token=${token}`;

      //query condition for reciver
      if (searchMailReciever) {
        requestUrl = requestUrl + `&mailreciever=${searchMailReciever}`;
      }

      //query condition for sender
      if (searchMailSender) {
        requestUrl = requestUrl + `&mailsender=${searchMailSender}`;
      }

      //query condition for subject
      if (searchMailSubject != "") {
        requestUrl = requestUrl + `&mailsubject=${searchMailSubject}`;
      }

      //query condition for mail date
      if (searchMailDate != "") {
        requestUrl = requestUrl + `&maildate=${searchMailDate}`;
      }

      //query condition for mail templates
      if (searchMailTemplateSelect.length > 0) {
        requestUrl = requestUrl + `&mailtemplates=${searchMailTemplateSelect}`;
      }

      //query condition for mail labels
      if (searchMailLabelSelect.length > 0) {
        requestUrl = requestUrl + `&maillabels=${searchMailLabelSelect}`;
      }

      //query condition for reserve customer id
      if (searchMailReserveId !== "") {
        requestUrl = requestUrl + `&mailreserveid=${searchMailReserveId}`;
      }

      console.log('get messages request url',requestUrl);

      const response = await getData(requestUrl);

      console.log("get messages response ========>>>", response);

      if (response.data) {
        setConversationList(response.data);
        setResponseReceived(true);
        setRecords(response.data.length);
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsConversationLoading(false);
    }
  };

  //html block for sender column
  const senderBlockHtml = ({ dataItem }) => {
    return (
      <div>
        <div className="d-flex align-items-center gap-3">
          <div className="sent-to">
            <div className="profile d-flex gap-2 align-items-center mb-1">
              <div className="img rounded-circle overflow-hidden">
                <img
                  src={
                    dataItem?.sender
                      ? dataItem?.sender?.photoimage
                        ? url.SERVER_URL +
                          dataItem?.sender?.photoimage?.path
                        : assetImages.defaultUser
                      : assetImages.defaultUser
                  }
                  alt="Sender"
                  className="thumb-25 object-cover object-center"
                />
              </div>
              <a className="fw-medium text-dark">{dataItem.sendername}</a>
            </div>
            <p className="email d-flex gap-2 align-items-center">
              <span className="d-block material-symbols-outlined icon-sm">
                mail
              </span>
              <span className="text-dark">{dataItem.sendermail}</span>
            </p>
          </div>
        </div>
      </div>
    );
  };

  //html block for reciever column
  const receiverBlockHtml = ({ dataItem }) => {
    return (
      <div>
        <div
          className="d-flex align-items-center gap-3"
          onClick={() => {
            setViewConversationData(dataItem);
          }}
        >
          <div className="sent-to">
            <div className="profile d-flex gap-2 align-items-center mb-1">
              <div className="img rounded-circle overflow-hidden">
                <img
                  src={
                    dataItem?.receiver
                      ? dataItem?.receiver?.photoimage
                        ? url.SERVER_URL +
                          dataItem?.receiver?.photoimage?.path
                        : assetImages.defaultUser
                      : assetImages.defaultUser
                  }
                  alt="Receiver"
                  className="thumb-25 object-cover object-center"
                />
              </div>
              <a
                className="fw-medium text-dark"
                href="#EmailDetailsPopup"
                data-bs-toggle="offcanvas"
                role="button"
                aria-controls="EmailDetailsPopup"
              >
                {dataItem.receivername
                  ? dataItem.receivername
                  : dataItem.receivermail}
              </a>
            </div>

            <p className="email d-flex gap-2 align-items-center">
              <span className="d-block material-symbols-outlined icon-sm">
                mail
              </span>
              <a
                className="text-dark"
                href="#EmailDetailsPopup"
                data-bs-toggle="offcanvas"
                role="button"
                aria-controls="EmailDetailsPopup"
              >
                {dataItem.receivermail}
              </a>
            </p>
          </div>

          {dataItem.tracker == "2"
            ? (
                <span className="d-block material-symbols-outlined icon-md ms-auto text-success">
                  done_all
                </span>
              )
            : dataItem.tracker == "1"
            ? (
                <span className="d-block material-symbols-outlined icon-md ms-auto">
                  check
                </span>
              )
            : (
                <span className="d-block material-symbols-outlined icon-md ms-auto text-danger">
                  warning
                </span>
              )
          }

          {dataItem.uploads
            ? dataItem.uploads.length > 0 && (
                <span className="d-block material-symbols-outlined icon-sm">
                  attach_file
                </span>
              )
            : ""}
        </div>
      </div>
    );
  };

  // Column definitions
  const tableColumns = useMemo(() => [
    {
      id: "receivername",
      accessorKey: "receivername",
      header: t("Receiver / Delivery Status"),
      Cell: ({ row }) => receiverBlockHtml({ dataItem: row.original }),
      size: 300,
    },
    {
      id: "sender.name",
      accessorFn: (row) => row.sender?.name ?? "",
      header: t("Sender"),
      Cell: ({ row }) => senderBlockHtml({ dataItem: row.original }),
      size: 250,
    },
    {
      id: "subject",
      accessorKey: "subject",
      header: t("Subject"),
      size: 250,
    },
    {
      id: "reserveArrayString",
      accessorKey: "reserveArrayString",
      header: t("Customer ID"),
      size: 150,
    },
    {
      id: "sendfrom",
      accessorKey: "sendfrom",
      header: t("Send From"),
      size: 150,
    },
    {
      id: "maildate",
      accessorKey: "maildate",
      header: t("Date"),
      size: 150,
    },
    {
      id: "tagstring",
      accessorKey: "tagstring",
      header: t("Tags"),
      size: 200,
    },
  ], [conversationList]);

  /* hook to reload list */
  useEffect(() => {
    if (responseReceived === false) {
      console.log("Inbox useEffect inside ------>");
      getConversationList();
    }
  }, [responseReceived]);

  // reload request
  useEffect(() => {
    if (reloadConversationList) {
      getConversationList();
      setReloadConversationList(false);
    }
  }, [reloadConversationList]);

  useEffect(() => {
    if (
      searchMailReciever ||
      searchMailSender ||
      searchMailSubject != "" ||
      searchMailDate != "" ||
      searchMailTemplateSelect.length > 0 ||
      searchMailLabelSelect.length > 0 ||
      searchMailReserveId !== ""
    ) {
      getConversationList();
    }
  }, [
    searchMailReciever,
    searchMailSender,
    searchMailSubject,
    searchMailDate,
    searchMailTemplateSelect,
    searchMailLabelSelect,
    searchMailReserveId,
  ]);

  /* hook to hit exportExcel() function */
  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  /* set records based on conversationList changes */
  useEffect(() => {
    setRecords(conversationList.length);
  }, [conversationList]);

  /* sync selected count and IDs to parent */
  useEffect(() => {
    const selectedKeys = Object.keys(rowSelection).filter((key) => rowSelection[key]);
    checkedRecordCount(selectedKeys.length);
    setSelectedIds(selectedKeys);
  }, [rowSelection, conversationList]);

  return (
    <div className="table-responsive">
      <MaterialReactTable
        columns={tableColumns}
        data={conversationList}
        enableSorting
        enableFilters
        enableGlobalFilter={false}
        enableGrouping
        enableColumnOrdering
        enableStickyHeader
        enableRowSelection
        onRowSelectionChange={setRowSelection}
        getRowId={(row) => row._id}
        state={{ rowSelection }}
        muiTableContainerProps={{ sx: { maxHeight: screenHeight } }}
        muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
        muiTableBodyProps={{ sx: { overflow: "visible" } }}
        initialState={{
          pagination: { pageSize: 100, pageIndex: 0 },
          showColumnFilters: true,
        }}
      />
    </div>
  );
};

export default Inbox;
